import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { getPositionFromContext, JastBuildingVisitor } from './common';
export var StringVisitor = /*#__PURE__*/function (_JastBuildingVisitor) {
  _inherits(StringVisitor, _JastBuildingVisitor);
  var _super = _createSuper(StringVisitor);
  function StringVisitor() {
    var _this;
    _classCallCheck(this, StringVisitor);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "visitJqlString", function (ctx) {
      var text = _this.tokens.getText(ctx);
      var position = getPositionFromContext(ctx);
      var value;
      if (ctx.QUOTE_STRING()) {
        value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
      } else if (ctx.SQUOTE_STRING()) {
        value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
      } else {
        // unquoted string
        value = text;
      }
      return {
        text: text,
        value: value,
        position: position
      };
    });
    return _this;
  }
  return _createClass(StringVisitor);
}(JastBuildingVisitor);